/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Wait for the DOM to fully load
document.addEventListener('DOMContentLoaded', function () {
  // Select the dropdown
  const selectState = document.getElementById('shipping-estimator-province');
  if(selectState) {
    selectState.selectedIndex = 1; // Index starts at 0
  }
  // Alternatively, you can use value
  // Set the desired value
  //selectElement.value = "option2";
});

const SESSION_STORAGE_KEYS = {
  customKitchen: 'custom_kitchen_cabinets',
  customMirrors: 'custom_mirrors_form_data',
  customShowerScreens: 'custom_shower_screens_form_data',
  customVanityScreens: 'custom_vanity_screens_form_data',
};

const setCustomKitchenOptionArrayEntry = (category, value) => {
  const storedValues =
    getSessionStorage(SESSION_STORAGE_KEYS.customKitchen) || {};
  const oldValue = storedValues[category] || '';
  const closestDiv = document.getElementById(value).closest('.filter_head');
  const element = document.getElementById(value);

  if (!category || !value) return;

  if (oldValue && oldValue === value) {
    storedValues[category] = '';
    closestDiv.classList.remove('selected');
    element.classList.remove('selected');
  } else {
    storedValues[category] = value;
    if (oldValue) {
      document
        .getElementById(oldValue)
        .closest('.filter_head')
        .classList.remove('selected');
      document.getElementById(oldValue).classList.remove('selected');
    }
    element.classList.add('selected');
    closestDiv.classList.add('selected');
  }

  window.sessionStorage.setItem(
    SESSION_STORAGE_KEYS.customKitchen,
    JSON.stringify(storedValues)
  );
};

const toggleCustomVanitySectionAndSetOption = (section, category, value) => {
  const collectionContainer = document.querySelector(
    '[data-selected-collection]'
  );
  const prevSelectedCollection = collectionContainer.getAttribute(
    'data-selected-collection'
  );
  const sectionElement = document.querySelector(
    `[data-collection="${section}"]`
  );

  if (!sectionElement) return;

  if (prevSelectedCollection && prevSelectedCollection !== section) {
    document.querySelector(
      `[data-collection="${prevSelectedCollection}"]`
    ).style.display = 'none';
  }

  collectionContainer.setAttribute('data-selected-collection', section);

  if (
    sectionElement.style.display === 'none' ||
    sectionElement.style.display === ''
  ) {
    sectionElement.style.display = 'flex';
  } else {
    sectionElement.style.display = 'none';
  }

  setCustomVanityScreensOption(category, value);
};

const VANITY_MAX_STEPS_MAP = {
  'Floor Standing': 13,
  'Wall Hung': 13,
  'With Legs': 10,
  'Cabinet Only': 7,
}

const setCustomVanityScreensOption = (category, value) => {
  if (category === 'Collection' && value) {
    selectedCollection = value;
    MAX_STEP = VANITY_MAX_STEPS_MAP[value] || 13;
  }

  const storedValues =
    getSessionStorage(SESSION_STORAGE_KEYS.customVanityScreens) || {};
  if (!category || !value) return;
  storedValues[category] = value;
  window.sessionStorage.setItem(
    SESSION_STORAGE_KEYS.customVanityScreens,
    JSON.stringify(storedValues)
  );
};

const getSessionStorage = (key) =>
  JSON.parse(window.sessionStorage.getItem(key));
const clearSessionStorage = (key) => window.sessionStorage.removeItem(key);

function toggleDialog(data) {
  const dialog = document.querySelector('dialog');
  if (dialog.open) {
    dialog.close();
  } else {
    resetContactFields();
    setDialogValues(data);
    dialog.showModal();
  }
}

function resetContactFields () {
  const address = document.getElementById('contact-address');
  const phone = document.getElementById('contact-phone');
  if (address && phone) {
    const addressDefaultSpan = address.querySelector('span[data-preview]');
    const phoneDefaultSpan = phone.querySelector('span[data-preview]');
    const addressFullSpan = address.querySelector('span[data-full]');
    const phoneFullSpan = phone.querySelector('span[data-full]');
    if (addressDefaultSpan && phoneDefaultSpan && addressFullSpan && phoneFullSpan) {
      addressDefaultSpan.style.display = 'block';
      phoneDefaultSpan.style.display = 'block';
      addressFullSpan.style.display = 'none';
      phoneFullSpan.style.display = 'none';
      addressDefaultSpan.setAttribute('data-is-active', 'true');
      phoneDefaultSpan.setAttribute('data-is-active', 'true');
      addressFullSpan.setAttribute('data-is-active', 'false');
      phoneFullSpan.setAttribute('data-is-active', 'false');
    }
  }
}

function toggleViewField(element) {
  const defaultSpan = element.querySelector('span[data-preview]');
  const fullSpan = element.querySelector('span[data-full]');

  if (!defaultSpan || !fullSpan) return;

  if (defaultSpan.getAttribute('data-is-active') === 'true') {
    fullSpan.style.display = 'block';
    defaultSpan.style.display = 'none';
    defaultSpan.setAttribute('data-is-active', 'false');
    fullSpan.setAttribute('data-is-active', 'true');
  } else {
    fullSpan.style.display = 'none';
    defaultSpan.style.display = 'block';
    defaultSpan.setAttribute('data-is-active', 'true');
    fullSpan.setAttribute('data-is-active', 'false');
  }
}

function setDialogValues(data) {
  const logo = document.getElementById('partner-logo');
  logo.src = data.logo || '';
  logo.alt = data.name || `${data.name} Partner Logo`;
  document.getElementById('partner-name').innerText = data.name || '';
  document.getElementById('showcase-title').innerText =
    'About ' + (data.name || '');
  document.getElementById('showcase-description').innerText =
    data.description || '';
  document.getElementById('dialog_form-title').innerText =
    'Contact ' + (data.name || '');

  document.getElementById('badges').innerHTML =
    data.badges
      .split(',')
      .map((badge) => `<span class="badge">${badge.trim()}</span>`)
      .join('') || '';
  document.getElementById('member-since').innerText =
    'Member Since: ' + data.member_since || '';
  document
    .getElementById('contact-address')
    .querySelector('span[data-full]').innerText = data.address || '';
  document
    .getElementById('contact-phone')
    .querySelector('span[data-full]').innerText = data.phone || '';
  document.getElementById('partner-email').value = data.email || '';

  const inst = document.getElementById('instagram_social');
  const facebook = document.getElementById('facebook_social');
  const twitter = document.getElementById('twitter_social');
  const youtube = document.getElementById('youtube_social');
  const linkedin = document.getElementById('linkedin_social');
  const pinterest = document.getElementById('pinterest_social');

  if (data.instagram_link) {
    inst.style.display = 'inline-block';
    inst.href = data.instagram_link;
  } else {
    inst.style.display = 'none';
  }

  if (data.facebook_link) {
    facebook.style.display = 'inline-block';
    facebook.href = data.facebook_link;
  } else {
    facebook.style.display = 'none';
  }

  if (data.twitter_link) {
    twitter.style.display = 'inline-block';
    twitter.href = data.twitter_link;
  } else {
    twitter.style.display = 'none';
  }

  if (data.youtube_link) {
    youtube.style.display = 'inline-block';
    youtube.href = data.youtube_link;
  } else {
    youtube.style.display = 'none';
  }

  if (data.linkedin_link) {
    linkedin.style.display = 'inline-block';
    linkedin.href = data.linkedin_link;
  } else {
    linkedin.style.display = 'none';
  }

  if (data.pinterest_link) {
    pinterest.style.display = 'inline-block';
    pinterest.href = data.pinterest_link;
  } else {
    pinterest.style.display = 'none';
  }

  const showcaseContainer = document.getElementById('showcase-images');
  showcaseContainer.innerHTML = '';
  if (data.showcase_images && data.showcase_images.length > 0) {
    data.showcase_images.forEach((imgSrc, idx) => {
      if (imgSrc) {
        const divElement = document.createElement('div');
        const title = document.createElement('p');
        const oneliner = document.createElement('p');
        const imageElement = document.createElement('img');

        imageElement.src = imgSrc;
        imageElement.alt = `Showcase Image ${idx + 1}`;
        imageElement.style = 'width: 100%; height: 90%; object-fit: contain;';
        divElement.className = 'showcase_images-wrapper';
        title.innerText = data[`showcase_title_${idx + 1}`] || '';
        title.style.fontSize = '16px';
        title.style.fontWeight = 'bold';
        title.style.margin = '0px';
        oneliner.style.fontSize = '16px';
        oneliner.style.margin = '0px';
        oneliner.innerText = data[`showcase_oneliner_${idx + 1}`] || '';
        divElement.appendChild(title);
        divElement.appendChild(oneliner);
        divElement.appendChild(imageElement);
        showcaseContainer.appendChild(divElement);
      }
    });
  }
}

/**
 * Request-a-quote flow marker + PDP "Added to quote" notice under ATC.
 * Marker is set when the shopper starts a quote. Notice shows when that marker
 * is present AND the product is in quote storage (RQ), not the Shopify cart.
 * Collection banner CTA switches to a continue label once the quote has items.
 */
(() => {
  const RFQ_STARTED_KEY = 'austpek-rfq-started';
  const STYLE_ID = 'apq-in-quote-notice-styles';

  const hasStartedRfq = () => {
    if (window.RQ && typeof window.RQ.isStarted === 'function') {
      return window.RQ.isStarted();
    }
    try {
      if (sessionStorage.getItem(RFQ_STARTED_KEY) === '1') return true;
    } catch (error) {
      // Fall through to cookie.
    }
    try {
      return /(?:^|;\s*)austpek-rfq-started=1(?:;|$)/.test(document.cookie);
    } catch (error) {
      return false;
    }
  };

  const getQuoteItemCount = () => {
    if (window.RQ && typeof window.RQ.getItemCount === 'function') {
      return window.RQ.getItemCount();
    }
    return 0;
  };

  const updateCollectionBannerQuoteButtons = () => {
    const buttons = document.querySelectorAll('[data-collection-banner-quote]');
    if (!buttons.length) return;

    const count = getQuoteItemCount();
    const showContinue = hasStartedRfq() && count > 0;

    for (const button of buttons) {
      const defaultLabel = button.getAttribute('data-label-default') || '';
      const continueTemplate = button.getAttribute('data-label-continue') || '';
      const continueTemplateOne = button.getAttribute('data-label-continue-one') || '';
      let label = defaultLabel;

      if (showContinue && continueTemplate) {
        const template = count === 1 && continueTemplateOne ? continueTemplateOne : continueTemplate;
        label = template.replaceAll('__COUNT__', String(count));
      }

      if (!label) continue;
      // Buttons with an icon keep it by exposing a dedicated label element.
      const labelEl = button.querySelector('[data-collection-banner-quote-label]') || button;
      labelEl.textContent = label;
    }
  };

  // Mirrors the quote drawer's progress: steps up to the current panel are filled once a quote has products.
  const getQuoteStep = () => {
    const panel = window.RQ && typeof window.RQ.getPanel === 'function' ? window.RQ.getPanel() : '';
    if (panel === 'project') return 2;
    if (panel === 'contact') return 3;
    return 1;
  };

  const updateQuoteSteps = () => {
    const lists = document.querySelectorAll('[data-quote-steps]');
    if (!lists.length) return;

    const active = hasStartedRfq() && getQuoteItemCount() > 0;
    const step = active ? getQuoteStep() : 0;

    for (const list of lists) {
      for (const item of list.querySelectorAll('[data-quote-step]')) {
        const index = Number(item.getAttribute('data-quote-step'));
        item.classList.toggle('is-active', index <= step);
        if (index === step) {
          item.setAttribute('aria-current', 'step');
        } else {
          item.removeAttribute('aria-current');
        }
      }
      for (const line of list.querySelectorAll('[data-quote-step-line]')) {
        line.classList.toggle('is-active', Number(line.getAttribute('data-quote-step-line')) <= step);
      }
    }
  };

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .apq-in-quote-notice {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        width: 100%;
        margin: 0;
        padding: 0.75rem 1rem;
        border: 1px solid #c8e6c9;
        border-radius: var(--button-border-radius, 4px);
        background: #e8f5e9;
        color: #2e7d32;
        text-decoration: none;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;
      }
      .apq-in-quote-notice:hover,
      .apq-in-quote-notice:focus-visible {
        color: #1b5e20;
        text-decoration: none;
      }
      .apq-in-quote-notice[hidden] {
        display: none !important;
      }
      .apq-in-quote-notice__icon {
        display: inline-flex;
        flex-shrink: 0;
        color: inherit;
      }
      .apq-in-quote-notice__text {
        font-size: 0.9375rem;
        font-weight: 700;
        line-height: 1.3;
        color: inherit;
      }
    `;
    document.head.appendChild(style);
  };

  const setNoticeVisibility = (notice, visible) => {
    notice.hidden = !visible;
    notice.dataset.inCart = visible ? 'true' : 'false';
  };

  const updateInQuoteNotices = () => {
    const notices = document.querySelectorAll('[data-apq-in-quote-notice]');
    if (!notices.length) return;

    ensureStyles();
    const started = hasStartedRfq();

    for (const notice of notices) {
      const productId = notice.dataset.productId || '';
      const inQuote = Boolean(
        started &&
        productId &&
        window.RQ &&
        typeof window.RQ.hasProduct === 'function' &&
        window.RQ.hasProduct(productId)
      );
      setNoticeVisibility(notice, inQuote);
    }
  };

  const refreshQuoteUi = () => {
    updateInQuoteNotices();
    updateCollectionBannerQuoteButtons();
    updateQuoteSteps();
  };

  const scheduleUpdate = () => {
    window.setTimeout(() => {
      refreshQuoteUi();
    }, 50);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshQuoteUi);
  } else {
    refreshQuoteUi();
  }

  document.addEventListener('rq:ready', scheduleUpdate);
  document.addEventListener('rq:change', scheduleUpdate);
  document.addEventListener('product:added', scheduleUpdate);
  window.addEventListener('pageshow', scheduleUpdate);
  window.addEventListener('focus', scheduleUpdate);
})();

/**
 * VO Product Options (bcpo) adds products through its own AJAX call whenever a product has virtual options or
 * add-on prices, bypassing the theme's product form. Afterwards it redirects to /cart unless a "bcpo:afterAdd"
 * handler returns true. We hand the add over to the theme so the cart drawer opens instead.
 * The handler has to be bound through the app's own jQuery (bcpo.$), which loads asynchronously.
 */
(function () {
  const onBcpoAfterAdd = function () {
    const $ = window.bcpo.$;
    const quantityInput = document.querySelector('#bcpo')?.closest('form')?.querySelector('[name="quantity"]');

    $('.r-apps-loader').addClass('r-apps-loader--hidden');
    $('form[action*="/cart/add"] [data-action="add-to-cart"]').prop('disabled', false);

    document.documentElement.dispatchEvent(
      new CustomEvent('product:added', {
        bubbles: true,
        detail: { quantity: parseInt(quantityInput?.value, 10) || 1 },
      })
    );

    return true;
  };

  /**
   * bcpo charges the add-on prices by intercepting Checkout and creating a draft order, but it only arms that
   * interception once its cached cart (bcpo.cart2) holds priced options. That cache is read on page load and
   * refreshed by bcpo's own post-add branch, which returning true above skips. So after an AJAX add the
   * mini-cart Checkout would submit natively and charge only the variant price. Re-sync whenever the cart
   * re-renders, and hold a Checkout click until the sync has run.
   */
  let pendingSync = null;
  const syncBcpoCart = () => {
    const bcpo = window.bcpo;
    if (!bcpo || !bcpo.$ || typeof bcpo.fixCartPrices !== 'function') return Promise.resolve();
    if (pendingSync) return pendingSync;

    pendingSync = fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      credentials: 'same-origin',
      headers: { 'Cache-Control': 'no-cache' },
    })
      .then((response) => response.json())
      .then((cart) => {
        bcpo.cart2 = cart;
        bcpo.fixCartPrices(false);
      })
      .catch(() => {})
      .finally(() => {
        pendingSync = null;
      });

    return pendingSync;
  };

  // `cart:rerendered` doesn't bubble outside the cart page, but the capture phase still reaches document.
  document.addEventListener('cart:rerendered', syncBcpoCart, true);

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest?.('#mini-cart [name="checkout"]');
      const bcpo = window.bcpo;
      if (!button || !bcpo || !bcpo.$ || bcpo.addedCartEvent) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      syncBcpoCart().then(() => {
        // Once armed, bcpo's own click handler takes over; otherwise nothing in the cart has add-ons.
        if (bcpo.addedCartEvent) button.click();
        else button.form?.requestSubmit(button);
      });
    },
    true
  );

  let attempts = 0;
  const bindWhenReady = () => {
    if (window.bcpo && window.bcpo.$) {
      window.bcpo.$(document).off('bcpo:afterAdd.theme').on('bcpo:afterAdd.theme', onBcpoAfterAdd);
      return;
    }
    if (++attempts < 100) window.setTimeout(bindWhenReady, 200);
  };

  bindWhenReady();
})();
